"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedService = exports.AsyncRelatedService = void 0;
const front_core_1 = require("@movecloser/front-core");
const abstract_1 = require("./abstract");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let AsyncRelatedService = class AsyncRelatedService extends abstract_1.AbstractAsyncRelatedService {
};
AsyncRelatedService = __decorate([
    front_core_1.Injectable()
], AsyncRelatedService);
exports.AsyncRelatedService = AsyncRelatedService;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let RelatedService = class RelatedService extends abstract_1.AbstractRelatedService {
};
RelatedService = __decorate([
    front_core_1.Injectable()
], RelatedService);
exports.RelatedService = RelatedService;
//# sourceMappingURL=service.js.map